import { jsx as u } from "react/jsx-runtime";
import { createContext as m, useState as f, useEffect as a, useContext as l } from "react";
import { defaultDesignValues as p } from "../themes/constants/default-design-values.mjs";
import { StoreThemeEnum as s } from "../themes/enums/store-theme-enum.mjs";
import { applyDesign as D } from "../themes/utils/apply-design.mjs";
const n = m(null), S = ({
  children: e,
  design: t,
  customRoot: r
}) => {
  const [o, i] = f(t);
  return a(() => {
    i(t);
  }, [t]), a(() => {
    D(o, r);
  }, [o, r]), /* @__PURE__ */ u(n.Provider, { value: { state: o, setState: i }, children: e });
}, c = () => {
  const e = l(n), t = (e == null ? void 0 : e.state.theme) === s.default, r = (e == null ? void 0 : e.state.primaryColor) === p[s.default].primaryColor && (e == null ? void 0 : e.state.theme) === s.default;
  if (!e)
    throw new Error("useDesignContext must be used within a DesignProvider");
  return { ...e, isDefaultTheme: t, isDefaultSioColor: r };
};
export {
  n as DesignContext,
  S as DesignProvider,
  c as useDesignContext
};
